module.exports = "https://cdn.realtymogul.com/static/media/icon_calculated.885f5473.svg";